const nativeBackDismissals: { dismiss: () => void }[] = [];

/** The app has one native Back listener, while image viewers mount across routes.
 * Register for the viewer's mounted lifetime so the last opened viewer consumes
 * Back before route navigation or app exit. Disposal removes only that registration
 * and is safe to repeat; no browser history entry is created. */
export function registerNativeBackDismiss(dismiss: () => void): () => void {
  const registration = { dismiss };
  nativeBackDismissals.push(registration);
  return () => {
    const index = nativeBackDismissals.indexOf(registration);
    if (index >= 0) nativeBackDismissals.splice(index, 1);
  };
}

/** Dismiss the active viewer first; otherwise navigate back or leave at the root. */
export function handleNativeBack(
  canGoBack: boolean,
  exitApp: () => Promise<void> | void,
): void {
  const activeDismissal = nativeBackDismissals[nativeBackDismissals.length - 1];
  if (activeDismissal) {
    activeDismissal.dismiss();
    return;
  }
  if (canGoBack) {
    window.history.back();
    return;
  }
  void exitApp();
}
